export default __webpack_public_path__ + "static/SR USA - Ingredient & Label - Caramel Colors - Statement-1a787b9655bccbb2631cedf3cc8dac92.pdf";